export default {

    getBusyState(state) {
        return !!state.busy;
    },

    getPaged(state) {
        return state.paged;
    },

    getFacets(state) {
        return state.facets;
    },

    getFilter(state) {
        return state.filter;
    },

    getSort(state) {
        return state.sort;
    },

    getRenderType(state) {
        return state.render_type;
    },

    getHtml(state) {
        return state.html;
    },

    getTarget(state) {
        return state.options.target;
    }

};
